import { Col, Flex, Input } from 'antd';
import { useCallback, type VFC } from 'react';
import { FilterControlButtons } from 'components/form/FilterControlButtons';
import { Button, Filter, FilterDivider, Form } from 'components';
import { Icon } from 'components/icon/Icon';
import { useHistory } from 'react-router-dom';
import { useUserInfo } from '@/hooks/useUser.js';
import { RoleName } from '@enmon/commons/lib/tools/index.js';
import type { Paths } from 'type-fest';
import { CommoditiesSelect } from '@/components/form/select/CommoditiesSelect.js';
import {
  DEFAULT_FILTER,
  type ManufacturersFilter,
  useManufacturersListFilterWithPagination,
} from '../hooks/useManufacturersListFilterWithPagination.ts.js';

export const ManufacturersListFilter: VFC = () => {
  const [form] = Form.useForm<ManufacturersFilter>();
  const history = useHistory();
  const { role } = useUserInfo() ?? {};
  const isMagicRole = role?.name === RoleName.Magic;

  const { filter, setFilterState, resetFilterState, setPaginationState } = useManufacturersListFilterWithPagination();

  // Handlers
  const handleReset = () => {
    form.setFieldsValue(DEFAULT_FILTER);

    resetFilterState();
    setPaginationState({
      current: 1,
    });
  };
  const handleCreate = useCallback(() => {
    history.push(`${history.location.pathname}/create`);
  }, [history]);

  const handleFinish = (values: ManufacturersFilter) => {
    setFilterState(values);
    setPaginationState({
      current: 1,
    });
  };

  return (
    <Filter form={form} initialValues={filter} onFinish={handleFinish}>
      <Form.Item label="Search" name={'search' satisfies Paths<ManufacturersFilter>}>
        <Input allowClear placeholder="E.g. Itron, Diehl, ..." />
      </Form.Item>

      <Form.Item label="Commodity" name={'commodity' satisfies Paths<ManufacturersFilter>}>
        <CommoditiesSelect />
      </Form.Item>

      <FilterDivider />

      <Flex align="end" flex={2} justify="space-between">
        <Col>
          <FilterControlButtons onClickReset={handleReset} />
        </Col>

        {isMagicRole && (
          <Col>
            <Button icon={<Icon iconString="plus" />} onClick={handleCreate}>
              Create new manufacturer
            </Button>
          </Col>
        )}
      </Flex>
    </Filter>
  );
};
